module.exports = __webpack_public_path__ + "img/Failed_Verification.f624901e.svg";